// Copyright (c) 2016 Deere & Company

import FactoryCodes, {getDefaultState} from '../state/factory-codes';
import actions from '../../actions-list';

const updateDemoRentalFactoryCode = (state, action) =>
    FactoryCodes.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_DEMO_RENTAL_FACTORY_CODE_SUCCESS]: updateDemoRentalFactoryCode
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/reducers/factory-codes.js